export default function React_JSXIf() {
  return (
    <div>
      <h1>React_JSXIf Component</h1>
      <p>This is the React_JSXIf tutorial page.</p>
    </div>
  );
}
